import router from '@/router';

/**
 * @description 获取语言类型对应的数据
 */
function getLang(type) {
  return require(`@/assets/lang/${type}.js`)
}

/**
 * @description 判断是否为VNode
 * @param {Object} node 被判断对象
 */
function selfIsVNode(node) {
  return (
    node !== null &&
    typeof node === 'object' &&
    node.hasOwnProperty('componentOptions')
  )
}

/**
 * @description json2Fromdata
 * @param {String} config
 */
function jsToFormData(config) { 
  const formData = new FormData();
  //循环传入的值转换formData
  Object.keys(config).forEach((key) => {
    formData.append(key, config[key]);
  })
  return formData;
}

/**
 * 复制字符串到剪贴板，入参为字符串
 * @param str
 */
function copyToClipboard(str) {
  const cInput = document.createElement('input')
  cInput.value = str
  document.body.appendChild(cInput)
  cInput.select()
  document.execCommand('Copy')
  cInput.remove()
}

/**
 * @description 对象深拷贝
 * @param {Object} p 被拷贝对象
 * @param {Object} c 拷贝数据存放对象
 */
function deepcopy(p) {
  return JSON.parse(JSON.stringify(p))
}

/**
 * 14位日期字符串格式化
 * @param {String} date 日期字符串
 * @param {String} divider 分隔符
 */
export const getDateTime = (date, divider = '-') => {
  return date.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, ['$1', '$2', '$3'].join(divider) + ' $4:$5:$6')
}
/**
 * 日期字符串格式化
 * @param {String} date 日期字符串
 * @param {String} divider 分隔符
 */
export const getDate = (date, divider = '-') => {
  if (date.length === 14) return getDateTime(date, divider)
  return date.replace(/(\d{4})[^\d]?(\d{2})[^\d]?(\d{2})/, ['$1', '$2', '$3'].join(divider))
}
/**
 * 日期字符串格式化
 * @param {String} date 日期字符串
 * @param {String} divider 分隔符
 */
export const getShortDate = (date, divider = '-') => {
  return date.replace(/(\d{4})[^\d]?(\d{2})[^\d]?(\d{2})/, ['$2', '$3'].join(divider))
}
/**
 * 日期格式化
 * @param {String} date 日期或日期字符串
 * @param {String} fmt 日期格式字符串
 */
export const formatDate = (date, fmt = 'yyyy-MM-dd') => {
  if (!date) date = new Date()
  if (typeof date === 'string') {
    date = new Date(getDate(date))
  }
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分钟
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '\u65e5', // 日
    '1': '\u4e00', // 一
    '2': '\u4e8c', // 二
    '3': '\u4e09', // 三
    '4': '\u56db', // 四
    '5': '\u4e94', // 五
    '6': '\u516d' // 六
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
const isDate = (date) => {
  return Object.prototype.toString.call(date) === '[object Date]'
}
/**
 * 获取某个日期加(负数则减)某个间隔后的日期
 * @param {Object} obj 日期偏移指数
 * @param {Date}|{String} date 日期或日期字符串
 * @param {Boolean} immutable 是否不改变原date对象，默认可改变
 */
export const getOffsetDate = (offsetObj, date, immutable) => {
  offsetObj = offsetObj || {}
  if (immutable && isDate(date)) {
    date = new Date(date.valueOf())
  }
  if (date && typeof date === 'string') {
    date = new Date(getDate(date, '/'))
  }
  if (!isDate(date)) {
    date = new Date()
  }
  offsetObj.year && date.setYear(date.getFullYear() + (+offsetObj.year))
  offsetObj.month && date.setMonth(date.getMonth() + (+offsetObj.month))
  offsetObj.day && date.setDate(date.getDate() + (+offsetObj.day))
  return date
}

/**
 * 个性化
 */
var service = {};

/**
 * 对外开放的调用函数
 * @param {Object} pageName 页面名称
 * @param {Object} funcName 个性化函数名称
 * @param {Object} defaultValue 默认返回值
 * @param {arg} defaultValue 个性化函数入参，如果需要回调则第二个参数为回调函数
 */
function call(pageName, funcName, defaultValue, ...arg) {
  if (service[pageName] && service[pageName][funcName]) {
    return service[pageName][funcName](arg);
  } else {
    if (typeof arg[1] === "function") {
      arg[1](defaultValue);
    }
    return defaultValue;
  }
}

/**
 * 遍历对象或数组
 * 注：回调函数中`return false`可中断循环的进行
 * @param {Object}|{Array} obj 要遍历的对象/数组
 * @param {Function} fn 回调函数
 */
function forEach(obj, fn) {
  if (obj === null || typeof obj === 'undefined') return
  if (typeof(obj) !== 'object') obj = [obj]
  if (typeof(obj) === 'array') {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (fn.call(obj[i], obj[i], i, obj) === false) break
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (fn.call(obj[key], obj[key], key, obj) === false) break
      }
    }
  }
}

/**
 * 防抖
 * @param {*} func 
 * @param {*} wait 
 * @returns 
 */
function debounce(func, wait) {
  let timerId
  return function (...args) {
    clearTimeout(timerId)
    timerId = setTimeout(function later() {
      timerId = null
      func.apply(null, args)
    }, wait)
  }
}

/**
 * 将数字转换为中文的金额
 * @method cnMoneyFormat
 * @param {Number} money 数字
 */
// function cnMoneyFormat(money) {
//   var cnMoney = "零元整";
//   var strOutput = "";
//   var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
//   money += "00";
//   var intPos = money.indexOf('.');
//   if (intPos >= 0) {
//      money = money.substring(0, intPos) + money.substr(intPos + 1, 2);
//   }
//   strUnit = strUnit.substr(strUnit.length - money.length);
//   for (var i = 0; i < money.length; i++) {
//      strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(money.substr(i, 1), 1) + strUnit.substr(i, 1);
//   }
//   cnMoney = strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
//   return cnMoney;
// }

function cnMoneyFormat(dValue) {
  if (dValue.toString().indexOf('元') >= 0) {
    dValue = dValue.slice(0, dValue.length - 1)
  }
  var maxDec = 2;
  // 验证输入金额数值或数值字符串：
  dValue = dValue.toString().replace(/,/g, "");
  dValue = dValue.replace(/^0+/, ""); // 金额数值转字符、移除逗号、移除前导零
  // 兼容当输出0.的场景时大写转换不报错
  if (dValue == "" || dValue == ".") {
      return "--";//零元整
  } // （错误：金额为空！）
  else if (isNaN(dValue)) {
    return "错误：金额不是合法的数值！";
  }
  var minus = ""; // 负数的符号“-”的大写：“负”字。可自定义字符，如“（负）”。
  var CN_SYMBOL = ""; // 币种名称（如“人民币”，默认空）
  if (dValue.length > 1) {
    if (dValue.indexOf('-') == 0) {
        dValue = dValue.replace("-", "");
        minus = "负";
    } // 处理负数符号“-”
    if (dValue.indexOf('+') == 0) {
        dValue = dValue.replace("+", "");
    } // 处理前导正数符号“+”（无实际意义）
  }
  // 变量定义：
  var vInt = "";
  var vDec = ""; // 字符串：金额的整数部分、小数部分
  var resAIW; // 字符串：要输出的结果
  var parts; // 数组（整数部分.小数部分），length=1时则仅为整数。
  var digits, radices, bigRadices, decimals; // 数组：数字（0~9——零~玖）；基（十进制记数系统中每个数字位的基是10——拾,佰,仟）；大基（万,亿,兆,京,垓,杼,穰,沟,涧,正）；辅币（元以下，角/分/厘/毫/丝）。
  var zeroCount; // 零计数
  var i, p, d; // 循环因子；前一位数字；当前位数字。
  var quotient, modulus; // 整数部分计算用：商数、模数。
  // 金额数值转换为字符，分割整数部分和小数部分：整数、小数分开来搞（小数部分有可能四舍五入后对整数部分有进位）。
  var NoneDecLen = (typeof (maxDec) == "undefined" || maxDec == null || Number(maxDec) < 0 || Number(maxDec) > 5); // 是否未指定有效小数位（true/false）
  parts = dValue.split('.'); // 数组赋值：（整数部分.小数部分），Array的length=1则仅为整数。
  if (parts.length > 1) {
    vInt = parts[0];
    vDec = parts[1]; // 变量赋值：金额的整数部分、小数部分
    if (NoneDecLen) {
        maxDec = vDec.length > 5 ? 5 : vDec.length;
    } // 未指定有效小数位参数值时，自动取实际小数位长但不超5。
    var rDec = Number("0." + vDec);
    rDec *= Math.pow(10, maxDec);
    rDec = Math.round(Math.abs(rDec));
    rDec /= Math.pow(10, maxDec); // 小数四舍五入
    var aIntDec = rDec.toString().split('.');
    if (Number(aIntDec[0]) == 1) {
        vInt = (Number(vInt) + 1).toString();
    } // 小数部分四舍五入后有可能向整数部分的个位进位（值1）
    if (aIntDec.length > 1) {
        vDec = aIntDec[1];
    } else {
        vDec = "";
    }
  } else {
    vInt = dValue;
    vDec = "";
    if (NoneDecLen) {
        maxDec = 0;
    }
  }
  if (vInt.length > 44) {
    return "错误：金额值太大了！整数位长【" + vInt.length.toString() + "】超过了上限——44位/千正/10^43（注：1正=1万涧=1亿亿亿亿亿，10^40）！";
  }
  // 准备各字符数组 Prepare the characters corresponding to the digits:
  digits = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); // 零~玖
  radices = new Array("", "拾", "佰", "仟"); // 拾,佰,仟
  bigRadices = new Array("", "万", "亿", "兆", "京", "垓", "杼", "穰", "沟", "涧", "正"); // 万,亿,兆,京,垓,杼,穰,沟,涧,正
  decimals = new Array("角", "分", "厘", "毫", "丝"); // 角/分/厘/毫/丝
  resAIW = ""; // 开始处理
  // 处理整数部分（如果有）
  if (Number(vInt) > 0) {
    zeroCount = 0;
    for (i = 0; i < vInt.length; i++) {
      p = vInt.length - i - 1;
      d = vInt.substr(i, 1);
      quotient = p / 4;
      modulus = p % 4;
      if (d == "0") {
          zeroCount++;
      } else {
          if (zeroCount > 0) {
              resAIW += digits[0];
          }
          zeroCount = 0;
          resAIW += digits[Number(d)] + radices[modulus];
      }
      if (modulus == 0 && zeroCount < 4) {
          resAIW += bigRadices[quotient];
      }
    }
    resAIW += "元";
  }
  // 处理小数部分（如果有）
  for (i = 0; i < vDec.length; i++) {
    d = vDec.substr(i, 1);
    if (d != "0") {
        resAIW += digits[Number(d)] + decimals[i];
    }
  }
  // 处理结果
  if (resAIW == "") {
    resAIW = "零" + "元";
  } // 零元
  if (vDec == "") {
    resAIW += "整";
  } // ...元整
  resAIW = CN_SYMBOL + minus + resAIW; // 人民币/负......元角分/整
  return resAIW;
}

//去除字符串中文
function filterCnStr(str){
   return  str.replace(/[\u4E00-\u9FA5]/g, '');
}

/**
 * 将数字转换为中文的份额
 * @method cnShareFormat
 * @param {Number} money 数字
 */
function cnShareFormat(dValue) {  //这条是由钱转换而来的份额
  var maxDec = 2;
  // 验证输入金额数值或数值字符串：
  dValue = dValue.toString().replace(/,/g, "");
  dValue = dValue.replace(/^0+/, ""); // 金额数值转字符、移除逗号、移除前导零
  // 兼容当输出0.的场景时大写转换不报错
  if (dValue == "" || dValue == ".") {
      return "--";//零元份
  } // （错误：金额为空！）
  else if (isNaN(dValue)) {
      return "错误：份额不是合法的数值！";
  }
  var minus = ""; // 负数的符号“-”的大写：“负”字。可自定义字符，如“（负）”。
  var CN_SYMBOL = ""; // 币种名称（如“人民币”，默认空）
  if (dValue.length > 1) {
      if (dValue.indexOf('-') == 0) {
          dValue = dValue.replace("-", "");
          minus = "负";
      } // 处理负数符号“-”
      if (dValue.indexOf('+') == 0) {
          dValue = dValue.replace("+", "");
      } // 处理前导正数符号“+”（无实际意义）
  }
  // 变量定义：
  var vInt = "";
  var vDec = ""; // 字符串：金额的整数部分、小数部分
  var resAIW; // 字符串：要输出的结果
  var parts; // 数组（整数部分.小数部分），length=1时则仅为整数。
  var digits, radices, bigRadices, decimals; // 数组：数字（0~9——零~玖）；基（十进制记数系统中每个数字位的基是10——拾,佰,仟）；大基（万,亿,兆,京,垓,杼,穰,沟,涧,正）；辅币（元以下，角/分/厘/毫/丝）。
  var zeroCount; // 零计数
  var i, p, d; // 循环因子；前一位数字；当前位数字。
  var quotient, modulus; // 整数部分计算用：商数、模数。
  // 金额数值转换为字符，分割整数部分和小数部分：整数、小数分开来搞（小数部分有可能四舍五入后对整数部分有进位）。
  var NoneDecLen = (typeof (maxDec) == "undefined" || maxDec == null || Number(maxDec) < 0 || Number(maxDec) > 5); // 是否未指定有效小数位（true/false）
  parts = dValue.split('.'); // 数组赋值：（整数部分.小数部分），Array的length=1则仅为整数。
  if (parts.length > 1) {
      vInt = parts[0];
      vDec = parts[1]; // 变量赋值：金额的整数部分、小数部分
      if (NoneDecLen) {
          maxDec = vDec.length > 5 ? 5 : vDec.length;
      } // 未指定有效小数位参数值时，自动取实际小数位长但不超5。
      var rDec = Number("0." + vDec);
      rDec *= Math.pow(10, maxDec);
      rDec = Math.round(Math.abs(rDec));
      rDec /= Math.pow(10, maxDec); // 小数四舍五入
      var aIntDec = rDec.toString().split('.');
      if (Number(aIntDec[0]) == 1) {
          vInt = (Number(vInt) + 1).toString();
      } // 小数部分四舍五入后有可能向整数部分的个位进位（值1）
      if (aIntDec.length > 1) {
          vDec = aIntDec[1];
      } else {
          vDec = "";
      }
  } else {
      vInt = dValue;
      vDec = "";
      if (NoneDecLen) {
          maxDec = 0;
      }
  }
  if (vInt.length > 44) {
      return "错误：份额值太大了！整数位长【" + vInt.length.toString() + "】超过了上限——44位/千正/10^43（注：1正=1万涧=1亿亿亿亿亿，10^40）！";
  }
  // 准备各字符数组 Prepare the characters corresponding to the digits:
  digits = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); // 零~玖
  radices = new Array("", "拾", "佰", "仟"); // 拾,佰,仟
  bigRadices = new Array("", "万", "亿", "兆", "京", "垓", "杼", "穰", "沟", "涧", "正"); // 万,亿,兆,京,垓,杼,穰,沟,涧,正
  decimals = new Array("角", "分", "厘", "毫", "丝"); // 角/分/厘/毫/丝
  resAIW = ""; // 开始处理
  // 处理整数部分（如果有）
  if (Number(vInt) > 0) {
      zeroCount = 0;
      for (i = 0; i < vInt.length; i++) {
          p = vInt.length - i - 1;
          d = vInt.substr(i, 1);
          quotient = p / 4;
          modulus = p % 4;
          if (d == "0") {
              zeroCount++;
          } else {
              if (zeroCount > 0) {
                  resAIW += digits[0];
              }
              zeroCount = 0;
              resAIW += digits[Number(d)] + radices[modulus];
          }
          if (modulus == 0 && zeroCount < 4) {
              resAIW += bigRadices[quotient];
          }
      }
      resAIW += "";
  }else{
      resAIW += "零";
  }
  // 处理小数部分（如果有）
  if (vDec.length > 0) {
      resAIW+="点";  //有小数点时显示    
  }
  
  for (i = 0; i < vDec.length; i++) {
      d = vDec.substr(i, 1);
      if (d != "0") {
          resAIW += digits[Number(d)] ;//+ decimals[i]
      }else{
          resAIW +="零";
      }
  }
  resAIW+="份";
  // 处理结果
  if (resAIW == "") {
      resAIW = "零" + "份";
  } // 零元
  if (vDec == "") {
      resAIW += "";
  } // ...元整
  resAIW = CN_SYMBOL + minus + resAIW; // 人民币/负......元角分/整
  return resAIW;
}

//获取提示信息
function getTips(tipCode){
  var userInfo= JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo||'';
  var tip=userInfo?.tipRiskList?.filter(item=> item.code==tipCode )[0]?.tip||''
  var risk=userInfo?.tipRiskList?.filter(item=> item.code==tipCode )[0]?.risk||''
    return {
    tip:tip,
    risk:risk,
  } 
}

/***
 * 获取当前浏览器类型
 */
function myBrowser() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1 
              || userAgent.indexOf("OPR") > -1; //判断是否Opera浏览器

  var isQQ = userAgent.indexOf("QQBrowser") > -1; //判断是否QQBrowser浏览器

  var isUC = userAgent.indexOf("UBrowser") > -1; //判断是否UC浏览器

  var isIE = userAgent.indexOf("compatible") > -1
          && userAgent.indexOf("MSIE") > -1; //判断是否IE7~IE10浏览器

  var isIE11 = userAgent.indexOf("compatible") === -1
            && userAgent.indexOf("Trident") > -1; //判断是否IE11浏览器

  var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器

  var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器

  var isSafari = userAgent.indexOf("Safari") > -1
              && userAgent.indexOf("Chrome") === -1; //判断是否Safari浏览器

  var isChrome = userAgent.indexOf("Chrome") > -1 
              && userAgent.indexOf("; Win") > -1
              && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

  var is360 = userAgent.indexOf("Chrome") > -1 
            && userAgent.indexOf("; WOW") > -1
            && userAgent.indexOf("Safari") > -1; //判断360浏览器

  if (isIE) {
    var reIE = /MSIE (\d+)\.\d+;/;
    // match() 返回一个数组。数组第一项是匹配到的所有文本；数组第二项是正则中小括号匹配到的文本
    var matchReg = userAgent.match(reIE)
    var fIEVersion = matchReg[1];
    if (fIEVersion == 7) {
      return "IE7及其以下";
    } else if (fIEVersion == 8) {
      return "IE8";
    } else if (fIEVersion == 9) {
      return "IE9";
    } else if (fIEVersion == 10) {
      return "IE10";
    } else {
      return "0";
    }//IE版本过低
    return "IE";
  }
  if (isUC) {
    return "UC";
  }
  if (isQQ) {
    return "QQBrowser";
  }
  if (isIE11) {
    return "IE11";
  }
  if (isOpera) {
    return "Opera";
  }
  if (isEdge) {
    return "Edge";
  }
  if (isFF) {
    return "Firefox";
  }
  if (isSafari) {
    return "Safari";
  }
  if (isChrome) {
    return "Chrome";
  }
  if (is360) {
    return "360";
  }    
}

/**
 * post请求下载流文件
 */

async function downloadFileByPost(url, params) {
  let options = {
    method: 'post',
    url: url,
    data: JSON.stringify(params),
    filename: '',
    responseType: 'blob'
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(options.method, options.url, true)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.withCredentials = true
    xhr.responseType = options.responseType
    xhr.onreadystatechange = ()=> {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        if (xhr.response.type === 'application/json') {
          const reader = new FileReader()
          reader.addEventListener('loadend', ()=> {
            if (reader.readyState !== 2) {
              return reject(new Error('downlaod fail'))
            }
            let rs = ''
            try {
              rs = JSON.parse(reader.result)
            } catch (e) {
              return reject(e)
            }
            if (!rs.code || rs.code !== 0) {
              selfMsgBox.error({
                message: '提示',
                messageExtra: rs.msg,
                btns: ['确定']
              })
              return reject(new Error('downlaod fail'))
            } else {
              return resolve(rs)
            }
          })
          reader.readAsText(xhr.response)
        } else {
          if (xhr.response.size === 0) {
            selfMsgBox.error({
              message: '提示',
              messageExtra: '无下载内容',
              btns: ['确定']
            })
            return reject(new Error('xhr.response.size === 0'))
          }
          if (typeof window.chrome !== 'undefined') {
            // Chrome version
            let filename = ''
            console.log(options,'options')
            if (options.filename) {
              filename = options.filename
            } else {
              let disposition = xhr.getResponseHeader('Content-Disposition') || ''
              disposition = disposition.split(`filename*=utf-8''`)
              console.log(disposition, 'filename...')
              if (disposition.length > 1) {
                filename = decodeURI(disposition[1])
              } else {
                filename = 'file'
              }
            }
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = filename
            link.click()
          } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE version
            const blob = new Blob([xhr.response], { type: 'application/force-download' })
            window.navigator.msSaveBlob(blob, options.filename)
          } else {
            // Firefox version
            const file = new File([xhr.response], options.filename, { type: 'application/force-download' })
            window.open(URL.createObjectURL(file))
          }
          return resolve(true)
        }
      }
    }
    xhr.onerror = ()=> {
      return reject(new Error('下载失败'))
    }
    xhr.send(options.data)
  })
}


/**
 * get请求下载流文件
 */

async function downloadFileByGet(url) {
  let options = {
    method: 'get',
    url: url,
    filename: '',
    responseType: 'blob'
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(options.method, options.url, true)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.withCredentials = true
    xhr.responseType = options.responseType
    xhr.onreadystatechange = ()=> {
      console.log(xhr)
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        if (xhr.response.type === 'application/json') {
          const reader = new FileReader()
          reader.addEventListener('loadend', ()=> {
            if (reader.readyState !== 2) {
              return reject(new Error('downlaod fail'))
            }
            let rs = ''
            try {
              rs = JSON.parse(reader.result)
            } catch (e) {
              return reject(e)
            }
            if (!rs.code || rs.code !== 0) {
              selfMsgBox.error({
                message: '提示',
                messageExtra: rs.msg,
                btns: ['确定']
              })
              return reject(new Error('downlaod fail'))
            } else {
              return resolve(rs)
            }
          })
          reader.readAsText(xhr.response)
        } else {
          if (xhr.response.size === 0) {
            selfMsgBox.error({
              message: '提示',
              messageExtra: '无下载内容',
              btns: ['确定']
            })
            return reject(new Error('xhr.response.size === 0'))
          }
          if (typeof window.chrome !== 'undefined') {
            // Chrome version
            let filename = ''
            console.log(options,'options')
            if (options.filename) {
              filename = options.filename
            } else {
              let disposition = xhr.getResponseHeader('Content-Disposition') || ''
              disposition = disposition.split(`filename*=utf-8''`)
              console.log(disposition, 'filename...')
              if (disposition.length > 1) {
                filename = decodeURI(disposition[1])
              } else {
                filename = 'file'
              }
            }
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = filename
            link.click()
          } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE version
            const blob = new Blob([xhr.response], { type: 'application/force-download' })
            window.navigator.msSaveBlob(blob, options.filename)
          } else {
            // Firefox version
            const file = new File([xhr.response], options.filename, { type: 'application/force-download' })
            window.open(URL.createObjectURL(file))
          }
          return resolve(true)
        }
      }
    }
    xhr.onerror = ()=> {
      return reject(new Error('下载失败'))
    }
    xhr.send(options.data)
  })
}
  
/**
 * 获取静态资源文件内容
 */
function loadFile(path) {
  let xhr = new XMLHttpRequest()
  let okStatus = document.location.protocol === "file:" ? 0 : 200;
  xhr.open('GET', path, false);
  xhr.overrideMimeType("text/html;charset=utf-8");
  xhr.send(null);
  console.log(xhr.status,okStatus,xhr.responseText);
  return xhr.status === okStatus ? xhr.responseText : null;
}

/**
 * 动态填充占位符，并删除scrpit标签
 */
function dynamicPopulateHtml(htmlstr) {
  let now = new Date(), y = now.getFullYear(), m = now.getMonth() + 1, d = now.getDate();
  let dateStr =  y + '年' + (m < 10 ? '0' + m : m) + '月' + (d < 10 ? '0' + d : d) + '日';
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))?.user?.userInfo || {};
  let idNo = userInfo.identityno || userInfo.idno || '';
  idNo = idNo.includes('*') ? idNo : idNo.replace(/^(\d{4}).*?(\d{4})$/, '$1&zwnj;**********&zwnj;$2');
  let professionFlagStr = '';
  if (userInfo.accountInfo && userInfo.accountInfo.professionflag != null) {
    professionFlagStr = userInfo.accountInfo.professionflag == '1' ? '专业投资者' : '普通投资者';
  }
  // 占位符填充
  htmlstr = htmlstr.replace(/{dateTime}/g, dateStr)
    .replace(/{idNo}/g, idNo || '')
    .replace(/{custName}/g, userInfo.custname || '')
    .replace(/{custRiskLevel}/g, userInfo.riskabilityStr || '')
    .replace(/{fundRiskLevel}/g, userInfo.matchfundriskStr || '')
    .replace(/{professionFlag}/g, professionFlagStr);
  // 删除scrpit标签、button标签
  htmlstr = htmlstr.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<button\b[^<]*(?:(?!<\/button>)<[^<]*)*<\/button>/gi, '');
  return htmlstr;
}

/**
 * index：路由回退的步数，默认为1
 * 1. 如果有上一步路由，则回退index步，否则返回资产概况页
 */
function checkAndGoBack(index=1) {
  let historyLength = window.history.length;
  if (historyLength > index) { // 检查是否有上一步路由
    router.go(-index);
  } else {
    router.push('/home'); // 没有上一步，返回资产概况页 home ===> acco-query/asset-overview
  }
}

//十五或十八位身份证号验证
function checkIdNo(sId, force18) {
  var aCityStr = "11,12,13,14,15,21,22,23,31,32,33,34,35,36,37,41,42,43,44,45,46,50,51,52,53,54,61,62,63,64,65,71,81,82,91";
  var sBirthday;
  // 18位身份证判断
  if (sId.length == 18) {
    var iSum = 0;
    if (!/^\d{17}(\d|x)$/i.test(sId))
      return false;
    sId = sId.replace(/x$/i, "a");
    if (aCityStr.indexOf(sId.substr(0, 2)) === -1)
      return false;
    sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()))
      return false;
    for (var i = 17; i >= 0; i--)
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1)
      return false;
    return true;
  }
  // 15位身份证判断
  else if (!force18 && sId.length == 15) {
    if (!/^\d{15}$/i.test(sId))
      return false;
    if (aCityStr.indexOf(sId.substr(0, 2)) === -1)
      return false;
    sBirthday = "19" + sId.substr(6, 2) + "-" + Number(sId.substr(8, 2)) + "-" + Number(sId.substr(10, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()))
      return false;
    return true;
  } else {
    return false;
  }
}

export {
  getLang,
  selfIsVNode,
  jsToFormData,
  copyToClipboard,
  deepcopy,
  call as newealthProjectExtend,
  forEach as each,
  debounce,
  cnMoneyFormat,
  cnShareFormat,
  filterCnStr,
  getTips,
  myBrowser,
  downloadFileByPost,
  downloadFileByGet,
  loadFile,
  dynamicPopulateHtml,
  checkAndGoBack,
  checkIdNo
}
